import showErrorToast from "../../../../utilities/Toast/showErrorToast";
import useShopSections from "../../hooks/useShopSections";
import SectionProducts from "../SectionProducts/SectionProducts";
import useLoadingSimulation from "../../hooks/useLoadingSimulation";
import ProductSectionsLoading from "../ProductSectionsLoading/ProductSectionsLoading";

const ShopSections = ({ toast }) => {
  const { shopSections, isLoading } = useShopSections({ onError: showErrorToast(toast.current) });
  const isLoadingSimulation = useLoadingSimulation();

  if (isLoading) {
    return (
      <div className="my-8">
        <ProductSectionsLoading />
      </div>
    );
  }

  if (!shopSections?.length) return null;

  if (shopSections.length === 1) {
    return (
      <div id="shop-sections">
        <SectionProducts section={shopSections[0]} />
        <div className="flex flex-column gap-4"></div>
      </div>
    );
  }

  shopSections.sort((a, b) => a.levelsection - b.levelsection);

  return shopSections.map((section, index) => (
    <section key={index}>
      <SectionProducts section={section} />
    </section>
  ));
};

export default ShopSections;
